<template>
  <side-bar
    v-show="isSidebarActiveLocal"
    position-right
    class="z-10 cust-sidebar-width"
  >
    <div>
      <div class="flex add-sidebar-top bg-primary justify-between py-3 px-6">
        <h2 class="text-sm font-semibold text-white">Report Bug</h2>
        <feather-icon
          icon="XCircleIcon"
          class="text-white"
          svgClasses="w-4 font-bold cursor-pointer"
          @click="CrossPressed"
        ></feather-icon>
      </div>
      <div class="px-3 py-1 scroll-85vh">
        <b-form>
          <div class="pt-2">
            <label for="ftestcase" class="mb-1 text-xs">TestCase ID</label>
            <b-form-input
              :value="selectedCase.testCaseID"
              size="sm"
              placeholder="Enter your TicketID"
              class="bgf7fafe-aftr border-0 text-xs"
              readonly
            ></b-form-input>
            <!-- <textarea
              placeholder="Write a Test Case..."
              class="form-control form-control-muted bgf7fafe-aftr text-xs"
              rows="2"
            ></textarea> -->
          </div>
          <div class="pt-2">
            <label for="fdescription" class="mb-1 text-xs">Description</label>
            <textarea
              v-model="description"
              placeholder="Write a Description..."
              class="form-control form-control-muted bgf7fafe-aftr text-xs"
              rows="3"
            ></textarea>
          </div>
          <div class="pt-2">
            <label for="fseverity" class="mb-1 text-xs">Severity</label>
            <b-form-select
              size="sm"
              v-model="severity"
              :options="options"
              class="bgf7fafe-aftr shadow-none"
            ></b-form-select>
          </div>
        </b-form>
      </div>
      <footer class="footer-fix fixed bottom-0 w-1/4 mobile-sidebarfooter">
        <base-button
          block
          type="primary"
          class="rounded-none font-semibold text-white text-sm"
          >Report</base-button
        >
        <!-- @click="addBug" -->
      </footer>
    </div>
  </side-bar>
</template>
<script>
// import Repository from "@/builder/apis/Repository";
import { mapState } from "vuex";
export default {
  props: {
    isSidebarActive: {
      type: Boolean,
      required: true,
    },
    selectedCase: {
      type: Object,
    },
  },
  data() {
    return {
      selected: "B",
      caseID: this.selectedCase.testCaseID,
      description: "",
      severity: "Medium",
      options: [
        { value: "High", text: "High" },
        { value: "Medium", text: "Medium" },
        { value: "Low", text: "Low" },
      ],
    };
  },
  computed: {
    isSidebarActiveLocal: {
      get() {
        return this.isSidebarActive;
      },
      set(val) {
        if (!val) {
          this.$emit("closeSidebar");
        }
      },
    },

    ...mapState("design", ["selectedSprint", "selectedComponent"]),
    ...mapState("user", ["selectedProject"]),
  },
  components: {},
  methods: {
    CrossPressed() {
      this.isSidebarActiveLocal = false;
    },

    // async addBug() {
    //   return new Promise(async (resolve, reject) => {
    //     try {
    //       const { data } = await Repository.post("uibuilder/addBug", {
    //         projectName: this.selectedProject.projectName,
    //         tasklist: this.selectedSprint._id,
    //         pageID: this.selectedComponent._id,
    //         testCaseID: this.selectedCase._id,
    //         description: this.description,
    //         severity: this.severity,
    //         status: this.status
    //       });
    //       resolve(data);
    //     } catch (error) {
    //       reject(error);
    //     }
    //   });
    // }
  },
};
</script>
